import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Input } from "../components/ui/input";

export const AuthShell = ({ title, subtitle, children }) => (
  <div className="grid md:grid-cols-2 min-h-[calc(100vh-4rem)]">
    <div className="hidden md:block relative">
      <img src="/images/talent_female_2.jpg" alt="" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-black/40" />
      <p className="absolute bottom-12 left-12 font-display text-5xl font-bold max-w-sm leading-none text-shadow">Lights. Camera. <span className="text-primary">You.</span></p>
    </div>
    <div className="flex items-center px-6 md:px-16 py-16">
      <div className="w-full max-w-md fade-up">
        <h1 className="font-display text-4xl sm:text-5xl font-bold">{title}</h1>
        <p className="text-white/60 mt-3">{subtitle}</p>
        <div className="mt-10">{children}</div>
      </div>
    </div>
  </div>
);

export default function Login() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const { setUser } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", form);
      setUser(data);
      navigate(data.role === "admin" ? "/admin" : "/dashboard");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Log in" subtitle="Manage your profile, photos and messages.">
      <form onSubmit={submit} className="space-y-5" data-testid="login-form">
        <div>
          <label className="label-xs">Email</label>
          <Input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-2 h-12" data-testid="login-email-input" />
        </div>
        <div>
          <label className="label-xs">Password</label>
          <Input type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="mt-2 h-12" data-testid="login-password-input" />
        </div>
        {error && <p className="text-sm text-red-400" data-testid="login-error">{error}</p>}
        <button disabled={busy} className="w-full bg-primary text-primary-foreground py-4 font-bold uppercase text-sm tracking-wider hover:bg-[hsl(43,100%,60%)] transition-colors disabled:opacity-60" data-testid="login-submit-button">
          {busy ? "Logging in…" : "Log in"}
        </button>
        <p className="text-sm text-white/60">
          New here? <Link to="/register" className="text-primary hover:underline" data-testid="login-register-link">Create an account</Link>
        </p>
      </form>
    </AuthShell>
  );
}
